import React from "react";
import EmailEditor from "../emailEditor/EmailEditor";
import SmsEditor from "../smsEditor/SmsEditor";

const TemplateEditor = ({
  template,
  type,
  onSave,
  setTemplate,
  headerTemplates,
  footerTemplates,
}) => {
  if (type === "email") {
    return (
      <EmailEditor
        template={template}
        setTemplate={setTemplate}
        headerTemplates={headerTemplates}
        footerTemplates={footerTemplates}
      />
    );
  }
  return <SmsEditor template={template} onSave={onSave} />;
};

export default TemplateEditor;
